import type { Lang } from '../lib/i18n';
import { appStoreBadge, googlePlayBadge } from '../lib/storeBadges';

interface StoreBadgeStrings {
  appStoreSub: string;
  appStoreMain: string;
  appStoreAria: string;
  googlePlaySub: string;
  googlePlayMain: string;
  googlePlayAria: string;
}


interface StoreBadgesProps {
  iosHref: string;
  androidHref: string;
  s: StoreBadgeStrings;
  lang: Lang;
  height?: number;
}

/**
 * The official App Store / Google Play badges (localised artwork from public/badges),
 * used by every store CTA on the site. Auto-detects external (real store link, opens a
 * new tab) vs internal (funnel route, same tab) based on whether the href is absolute.
 */
export function StoreBadges({ iosHref, androidHref, s, lang, height = 52 }: StoreBadgesProps) {
  const external = (href: string) => href.startsWith('http');
  const img = { height, width: 'auto' } as const;

  return (
    <>
      <a
        href={iosHref}
        {...(external(iosHref) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        aria-label={s.appStoreAria}
        className="badge-press inline-flex"
      >
        <img src={appStoreBadge(lang)} alt={s.appStoreAria} style={img} />
      </a>
      <a
        href={androidHref}
        {...(external(androidHref) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        aria-label={s.googlePlayAria}
        className="badge-press inline-flex"
      >
        <img src={googlePlayBadge(lang)} alt={s.googlePlayAria} style={img} />
      </a>
    </>
  );
}
